<footer class="footer">
    <div class="nav">
        <div>
            <a
                href="https://www.carnegielearning.com/terms-of-use/"
                class="nav__link"
                target="_blank"
            >
                Terms of Use
            </a>
        </div>
        <div>
            <a
                href="https://www.carnegielearning.com/privacy-policy/"
                class="nav__link"
                target="_blank"
                >Privacy Policy</a
            >
        </div>
        <div>
            <a
                href="https://www.carnegielearning.com/lets-talk/#support"
                class="nav__link"
                target="_blank"
                >Contact Support</a
            >
        </div>
        <!-- Save for later -->
        <!--        <div>-->
        <!--            <a-->
        <!--                href="http://passport.myemcp.com/helpcenter"-->
        <!--                class="nav__link"-->
        <!--                target="_blank"-->
        <!--            >Help Center</a-->
        <!--            >-->
        <!--        </div>-->
    </div>
    <div class="footer-copyright">
        <i
            >All content &copy;
            <a
                class="footer-copyright__link"
                href="https://www.carnegielearning.com"
                target="_blank"
            >
                Carnegie Learning, LLC.</a
            >
            All rights reserved.</i
        >
    </div>
</footer>
